export type AssetCategory = 'bg' | 'player' | 'ai' | 'joint' | 'smoke' | 'hud' | 'ui' | 'particles';

export interface SvgAsset {
  key: string;
  path: string;
  width?: number;
  height?: number;
}

const svg = (key: string, file: string, width?: number, height?: number): SvgAsset => ({
  key,
  path: `assets/svg/${file}`,
  width,
  height
});

export const SVG_ASSETS: SvgAsset[] = [
  svg('bg_room_back', 'bg/bg_room_back.svg', 1600, 900),
  svg('bg_window_light', 'bg/bg_window_light.svg', 280, 340),
  svg('bg_couch', 'bg/bg_couch.svg', 1600, 400),
  svg('bg_carpet', 'bg/bg_carpet.svg', 1600, 200),
  svg('bg_lava_lamp_glow', 'bg/bg_lava_lamp_glow.svg', 320, 400),
  svg('bg_lava_lamp_base', 'bg/bg_lava_lamp_base.svg', 120, 200),
  svg('bg_lava_lamp_liquid', 'bg/bg_lava_lamp_liquid.svg', 120, 280),
  svg('bg_lava_lamp_glass', 'bg/bg_lava_lamp_glass.svg', 120, 280),
  svg('bg_lava_lamp_blob_1', 'bg/bg_lava_lamp_blob_1.svg', 80, 80),
  svg('bg_lava_lamp_blob_2', 'bg/bg_lava_lamp_blob_2.svg', 60, 60),
  svg('bg_lava_lamp_blob_3', 'bg/bg_lava_lamp_blob_3.svg', 50, 70),
  svg('bg_poster', 'bg/bg_poster.svg', 200, 280),

  svg('player_body', 'player/player_body.svg', 220, 320),
  svg('player_chest', 'player/player_chest.svg', 180, 100),
  svg('player_arm_left_idle', 'player/player_arm_left_idle.svg', 80, 200),
  svg('player_arm_right_idle', 'player/player_arm_right_idle.svg', 80, 200),
  svg('player_arm_right_holding', 'player/player_arm_right_holding.svg', 200, 180),
  svg('player_arm_right_passing', 'player/player_arm_right_passing.svg', 260, 140),
  svg('player_head_idle', 'player/player_head_idle.svg', 220, 240),
  svg('player_head_inhale', 'player/player_head_inhale.svg', 220, 240),
  svg('player_head_exhale', 'player/player_head_exhale.svg', 220, 240),
  svg('player_head_choke', 'player/player_head_choke.svg', 220, 240),
  svg('player_head_warning', 'player/player_head_warning.svg', 220, 240),
  svg('player_head_win', 'player/player_head_win.svg', 220, 240),
  svg('player_head_lose', 'player/player_head_lose.svg', 220, 240),
  svg('player_eyes_open', 'player/player_eyes_open.svg', 120, 30),
  svg('player_eyes_closed', 'player/player_eyes_closed.svg', 120, 30),

  svg('ai_body', 'ai/ai_body.svg', 220, 320),
  svg('ai_chest', 'ai/ai_chest.svg', 180, 100),
  svg('ai_arm_left_idle', 'ai/ai_arm_left_idle.svg', 80, 200),
  svg('ai_arm_right_idle', 'ai/ai_arm_right_idle.svg', 80, 200),
  svg('ai_arm_left_holding', 'ai/ai_arm_left_holding.svg', 200, 180),
  svg('ai_arm_left_passing', 'ai/ai_arm_left_passing.svg', 260, 140),
  svg('ai_head_idle', 'ai/ai_head_idle.svg', 220, 240),
  svg('ai_head_inhale', 'ai/ai_head_inhale.svg', 220, 240),
  svg('ai_head_exhale', 'ai/ai_head_exhale.svg', 220, 240),
  svg('ai_head_choke', 'ai/ai_head_choke.svg', 220, 240),
  svg('ai_head_warning', 'ai/ai_head_warning.svg', 220, 240),
  svg('ai_head_win', 'ai/ai_head_win.svg', 220, 240),
  svg('ai_head_lose', 'ai/ai_head_lose.svg', 220, 240),
  svg('ai_eyes_open', 'ai/ai_eyes_open.svg', 120, 30),
  svg('ai_eyes_closed', 'ai/ai_eyes_closed.svg', 120, 30),

  svg('joint_paper', 'joint/joint_paper.svg', 400, 60),
  svg('joint_filter', 'joint/joint_filter.svg', 100, 60),
  svg('joint_ember_idle', 'joint/joint_ember_idle.svg', 100, 100),
  svg('joint_ember_inhale', 'joint/joint_ember_inhale.svg', 140, 140),
  svg('joint_ember_warning', 'joint/joint_ember_warning.svg', 160, 160),
  svg('joint_ash_1', 'joint/joint_ash_1.svg', 40, 40),
  svg('joint_ash_2', 'joint/joint_ash_2.svg', 40, 40),
  svg('joint_ash_3', 'joint/joint_ash_3.svg', 40, 40),

  svg('smoke_puff_small', 'smoke/smoke_puff_small.svg', 100, 100),
  svg('smoke_puff_medium', 'smoke/smoke_puff_medium.svg', 180, 180),
  svg('smoke_puff_large', 'smoke/smoke_puff_large.svg', 260, 260),
  svg('smoke_haze_warning', 'smoke/smoke_haze_warning.svg', 1600, 900),
  svg('smoke_cloud_drift_1', 'smoke/smoke_cloud_drift_1.svg', 320, 140),
  svg('smoke_cloud_drift_2', 'smoke/smoke_cloud_drift_2.svg', 280, 110),

  svg('hud_lung_frame', 'hud/hud_lung_frame.svg', 320, 40),
  svg('hud_lung_fill_mask', 'hud/hud_lung_fill_mask.svg', 300, 36),
  svg('hud_lung_icon', 'hud/hud_lung_icon.svg', 60, 60),
  svg('hud_choke_frame', 'hud/hud_choke_frame.svg', 320, 24),
  svg('hud_choke_fill_mask', 'hud/hud_choke_fill_mask.svg', 224, 16),
  svg('hud_score_panel', 'hud/hud_score_panel.svg', 340, 120),
  svg('hud_turn_arrow', 'hud/hud_turn_arrow.svg', 160, 90),
  svg('hud_combo_ring', 'hud/hud_combo_ring.svg', 200, 200),
  svg('hud_mute_on', 'hud/hud_mute_on.svg', 60, 60),
  svg('hud_mute_off', 'hud/hud_mute_off.svg', 60, 60),
  svg('hud_qte_frame', 'hud/hud_qte_frame.svg', 440, 60),
  svg('hud_qte_track', 'hud/hud_qte_track.svg', 400, 28),
  svg('hud_qte_golden', 'hud/hud_qte_golden.svg', 48, 40),
  svg('hud_qte_line', 'hud/hud_qte_line.svg', 12, 48),

  svg('ui_logo', 'ui/ui_logo.svg', 800, 240),
  svg('ui_btn_start', 'ui/ui_btn_start.svg', 320, 96),
  svg('ui_btn_start_hover', 'ui/ui_btn_start_hover.svg', 320, 96),
  svg('ui_btn_replay', 'ui/ui_btn_replay.svg', 320, 96),
  svg('ui_btn_replay_hover', 'ui/ui_btn_replay_hover.svg', 320, 96),
  svg('ui_btn_menu', 'ui/ui_btn_menu.svg', 320, 96),
  svg('ui_btn_menu_hover', 'ui/ui_btn_menu_hover.svg', 320, 96),
  svg('ui_btn_howto', 'ui/ui_btn_howto.svg', 320, 96),
  svg('ui_btn_howto_hover', 'ui/ui_btn_howto_hover.svg', 320, 96),
  svg('ui_btn_hs', 'ui/ui_btn_hs.svg', 320, 96),
  svg('ui_btn_hs_hover', 'ui/ui_btn_hs_hover.svg', 320, 96),
  svg('ui_card_easy', 'ui/ui_card_easy.svg', 240, 320),
  svg('ui_card_medium', 'ui/ui_card_medium.svg', 240, 320),
  svg('ui_card_hard', 'ui/ui_card_hard.svg', 240, 320),
  svg('ui_card_narco', 'ui/ui_card_narco.svg', 240, 320),
  svg('ui_banner_winner', 'ui/ui_banner_winner.svg', 800, 220),
  svg('ui_banner_loser', 'ui/ui_banner_loser.svg', 800, 220),
  svg('ui_banner_draw', 'ui/ui_banner_draw.svg', 800, 220),
  svg('ui_high_score_panel', 'ui/ui_high_score_panel.svg', 600, 540),

  // Shop UI
  svg('ui_coin', 'ui/ui_coin.svg', 40, 40),
  svg('ui_flip_coin', 'ui/ui_flip_coin.svg', 200, 200),
  svg('ui_shop_card_bg', 'ui/ui_shop_card_bg.svg', 280, 380),
  svg('ui_shop_card_equipped', 'ui/ui_shop_card_equipped.svg', 280, 380),
  svg('ui_btn_shop', 'ui/ui_btn_shop.svg', 320, 96),
  svg('ui_btn_shop_hover', 'ui/ui_btn_shop_hover.svg', 320, 96),
  svg('ui_badge_owned', 'ui/ui_badge_owned.svg', 120, 40),
  svg('ui_badge_soon', 'ui/ui_badge_soon.svg', 100, 36),

  // Skin: Rabbi
  svg('rabbi_body', 'rabbi/rabbi_body.svg', 220, 320),
  svg('rabbi_chest', 'rabbi/rabbi_chest.svg', 180, 100),
  svg('rabbi_arm_left_idle', 'rabbi/rabbi_arm_left_idle.svg', 80, 200),
  svg('rabbi_arm_left_holding', 'rabbi/rabbi_arm_left_holding.svg', 200, 180),
  svg('rabbi_arm_left_passing', 'rabbi/rabbi_arm_left_passing.svg', 260, 140),
  svg('rabbi_arm_right_idle', 'rabbi/rabbi_arm_right_idle.svg', 80, 200),
  svg('rabbi_head_idle', 'rabbi/rabbi_head_idle.svg', 220, 240),
  svg('rabbi_head_inhale', 'rabbi/rabbi_head_inhale.svg', 220, 240),
  svg('rabbi_head_exhale', 'rabbi/rabbi_head_exhale.svg', 220, 240),
  svg('rabbi_head_choke', 'rabbi/rabbi_head_choke.svg', 220, 240),
  svg('rabbi_head_warning', 'rabbi/rabbi_head_warning.svg', 220, 240),
  svg('rabbi_head_win', 'rabbi/rabbi_head_win.svg', 220, 240),
  svg('rabbi_head_lose', 'rabbi/rabbi_head_lose.svg', 220, 240),
  svg('rabbi_eyes_open', 'rabbi/rabbi_eyes_open.svg', 120, 30),
  svg('rabbi_eyes_closed', 'rabbi/rabbi_eyes_closed.svg', 120, 30),

  // Skin: Punk
  svg('punk_body', 'punk/punk_body.svg', 220, 320),
  svg('punk_chest', 'punk/punk_chest.svg', 180, 100),
  svg('punk_arm_left_idle', 'punk/punk_arm_left_idle.svg', 80, 200),
  svg('punk_arm_left_holding', 'punk/punk_arm_left_holding.svg', 200, 180),
  svg('punk_arm_left_passing', 'punk/punk_arm_left_passing.svg', 260, 140),
  svg('punk_arm_right_idle', 'punk/punk_arm_right_idle.svg', 80, 200),
  svg('punk_head_idle', 'punk/punk_head_idle.svg', 220, 240),
  svg('punk_head_inhale', 'punk/punk_head_inhale.svg', 220, 240),
  svg('punk_head_exhale', 'punk/punk_head_exhale.svg', 220, 240),
  svg('punk_head_choke', 'punk/punk_head_choke.svg', 220, 240),
  svg('punk_head_warning', 'punk/punk_head_warning.svg', 220, 240),
  svg('punk_head_win', 'punk/punk_head_win.svg', 220, 240),
  svg('punk_head_lose', 'punk/punk_head_lose.svg', 220, 240),
  svg('punk_eyes_open', 'punk/punk_eyes_open.svg', 120, 30),
  svg('punk_eyes_closed', 'punk/punk_eyes_closed.svg', 120, 30),

  // Skin: Drag Queen
  svg('dragqueen_body', 'dragqueen/dragqueen_body.svg', 220, 320),
  svg('dragqueen_chest', 'dragqueen/dragqueen_chest.svg', 180, 100),
  svg('dragqueen_arm_left_idle', 'dragqueen/dragqueen_arm_left_idle.svg', 80, 200),
  svg('dragqueen_arm_left_holding', 'dragqueen/dragqueen_arm_left_holding.svg', 200, 180),
  svg('dragqueen_arm_left_passing', 'dragqueen/dragqueen_arm_left_passing.svg', 260, 140),
  svg('dragqueen_arm_right_idle', 'dragqueen/dragqueen_arm_right_idle.svg', 80, 200),
  svg('dragqueen_head_idle', 'dragqueen/dragqueen_head_idle.svg', 220, 240),
  svg('dragqueen_head_inhale', 'dragqueen/dragqueen_head_inhale.svg', 220, 240),
  svg('dragqueen_head_exhale', 'dragqueen/dragqueen_head_exhale.svg', 220, 240),
  svg('dragqueen_head_choke', 'dragqueen/dragqueen_head_choke.svg', 220, 240),
  svg('dragqueen_head_warning', 'dragqueen/dragqueen_head_warning.svg', 220, 240),
  svg('dragqueen_head_win', 'dragqueen/dragqueen_head_win.svg', 220, 240),
  svg('dragqueen_head_lose', 'dragqueen/dragqueen_head_lose.svg', 220, 240),
  svg('dragqueen_eyes_open', 'dragqueen/dragqueen_eyes_open.svg', 120, 30),
  svg('dragqueen_eyes_closed', 'dragqueen/dragqueen_eyes_closed.svg', 120, 30),

  svg('particle_smoke', 'particles/particle_smoke.svg', 40, 40),
  svg('particle_ash', 'particles/particle_ash.svg', 20, 20),
  svg('particle_ember', 'particles/particle_ember.svg', 20, 20),
  svg('particle_sparkle', 'particles/particle_sparkle.svg', 24, 24)
];

export interface AudioAsset {
  key: string;
  path: string;
  loop?: boolean;
}

export const AUDIO_ASSETS: AudioAsset[] = [
  { key: 'sfx_inhale', path: 'assets/audio/sfx/inhale.mp3' },
  { key: 'sfx_exhale', path: 'assets/audio/sfx/exhale.mp3' },
  { key: 'sfx_ember', path: 'assets/audio/sfx/ember.mp3' },
  { key: 'sfx_cough', path: 'assets/audio/sfx/cough.mp3' },
  { key: 'sfx_win', path: 'assets/audio/sfx/win.mp3' },
  { key: 'sfx_lose', path: 'assets/audio/sfx/lose.mp3' },
  { key: 'sfx_click', path: 'assets/audio/sfx/click.mp3' },
  { key: 'music_chill', path: 'assets/audio/music/chill_loop.mp3', loop: true }
];
